<div style="position:fixed; z-index:9999; top:0px;left:0;height:100%;width:100%;background:rgba(0, 0, 0, 0.8)">
    <div class="container">

        <div class="container-center">
                
            <div class="form-center">

                <div class="container-fluid  " >
                    
                        <div class="pull-left">
                  
                            <a href="http://www.edr-software.com/" target="_blank">
                                <img class="header-logo" src="assets/edr-logo.svg" alt="Logo" />
                            </a>
                        </div>
                  
                    
                  </div>

                <div class="form-container">
                    <h3 class="title">{{ 'weblink.login.title' | translate }}</h3>  
                <form name="form"  (ngSubmit)="f.form.valid && login()"  #f="ngForm" novalidate>
                  
                  <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
                        
                        <input autofocus type="text" placeholder="{{ 'weblink.login.placeHolder' | translate }}" class="form-control" 
                                name="username"  [(ngModel)]="user" #username="ngModel"  required />
                        <!-- <div *ngIf="f.submitted && !username.valid" class="help-block">{{ 'um-web.forgotpsw.form.userError' | translate }}</div> -->
                    </div>
                    
                    <div class="form-group">
                        <div class="row">
                                <div class="col-xs-12 col-md-12">
                                        <button [disabled]="!f.valid " class="btn btn-primary docma-bg-purple docma-c-white margin-left"><span class="glyphicon glyphicon-log-in"  ></span> {{ 'weblink.button.login' | translate }}</button>
                                </div>
                        </div>
    
                    </div>
                </form>
                </div>

              
            </div>
        </div>
    </div>
</div>
  